<template>
    <div class="faq-container">
        <!-- HEADER -->
        <section class="faq-header">
            <v-container>
                <div class="header-content">
                    <h1 class="faq-title">Часто спрашиваемые вопросы </h1>
                    <p class="faq-subtitle">Всё, что вам нужно знать о FLASHX</p>
                </div>
            </v-container>
        </section>

        <!-- FAQ CONTENT -->
        <section class="faq-content">
            <v-container>
                <v-row>
                    <v-col cols="12" lg="8" offset-lg="2">
                        <div class="faq-list">
                            <div class="faq-item" v-for="(item, index) in faqItems" :key="index">
                                <div class="faq-question" @click="toggleItem(index)">
                                    <h3>{{ item.question }}</h3>
                                    <span class="toggle-icon" :class="{ active: item.open }">+</span>
                                </div>
                                <transition name="expand">
                                    <div class="faq-answer" v-if="item.open">
                                        <p>{{ item.answer }}</p>
                                    </div>
                                </transition>
                                <div class="faq-divider"></div>
                            </div>
                        </div>

                        <!-- CONTACT SECTION -->
                        <div class="contact-section">
                            <h3>Остались вопросы?</h3>
                            <p>Не можете найти ответ? Наша служба поддержки всегда готова помочь.</p>
                            <a href="https://t.me/flashxsupport_bot" target="_blank" rel="noopener noreferrer" class="btn-contact">
                                Связаться с поддержкой
                            </a>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        faqItems: [
            {
                question: 'Как работает FLASHX?',
                answer: 'FLASHX создаёт защищённый туннель между вашим устройством и удалённым сервером. Весь трафик проходит через этот туннель в зашифрованном виде, поэтому провайдер, сайты и третьи лица не могут увидеть, что вы делаете в сети.',
                open: false
            },
            {
                question: 'FLASHX замедляет интернет-соединение?',
                answer: 'Нет. FLASHX оптимизирован для скорости с настроенными серверами. Большинство пользователей испытывают минимальное влияние на скорость соединения, а многие отмечают более высокие скорости, чем предоставляют наши конкуренты.',
                open: false
            },
            {
                question: 'Сколько устройств я могу использовать одновременно?',
                answer: 'Подписка FLASHX позволяет использовать сервис на 5 устройствах одновременно. Это включает смартфоны, планшеты, компьютеры и маршрутизаторы.',
                open: false
            },
            {
                question: 'Какие методы оплаты вы принимаете?',
                answer: 'Мы принимаем все основные методы платежей (Debit Card/Crypto). Все транзакции безопасны и зашифрованы.',
                open: false
            },
            {
                question: 'Может ли FLASHX обойти географические ограничения?',
                answer: 'FLASHX может помочь вам получить доступ к контенту из разных регионов, маршрутизируя ваше соединение через серверы в этих местах. Однако мы призываем ответственное использование и соответствие местному законодательству.',
                open: false
            },
            {
                question: 'Действительно ли политика нулевого логирования реализована?',
                answer: 'Да! Наша политика нулевого логирования ежегодно независимо проверяется сторонними компаниями, занимающимися безопасностью. Мы не собираем, не сохраняем и не отслеживаем вашу активность.',
                open: false
            },
            {
                question: 'Какой клиент использовать для FLASHX?',
                answer: 'Android: v2RayTun, V2RayNG, nekobox/nekoray, Hiddify \n IOS/MacOS: Streisand, Hiddify \n Windows: Nekobox/Nekoray, Hiddify',
                open: false
            }
        ]
    }),
    methods: {
        toggleItem(index) {
            this.faqItems[index].open = !this.faqItems[index].open;
        }
    }
}
</script>

<style scoped>
    .faq-container {
        background: #ffffff;
        color: #000000;
    }

    /* ============ HEADER ============ */
    .faq-header {
        padding: 100px 0 60px;
        background: linear-gradient(135deg, #ffffff 0%, #f8f8f8 50%, #f0f0f0 100%);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }

    .header-content {
        text-align: center;
        animation: slideInDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    @keyframes slideInDown {
        from {
            opacity: 0;
            transform: translateY(-30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .faq-title {
        font-size: 56px;
        font-weight: 800;
        color: #000000;
        margin-bottom: 16px;
        letter-spacing: -1px;
    }

    .faq-subtitle {
        font-size: 18px;
        color: #666666;
        max-width: 500px;
        margin: 0 auto;
    }

    /* ============ FAQ CONTENT ============ */
    .faq-content {
        padding: 80px 0;
    }

    .faq-list {
        animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    @keyframes slideInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .faq-item {
        margin-bottom: 24px;
    }

    .faq-question {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px 0;
        cursor: pointer;
        transition: all 0.3s;
        user-select: none;
    }

    .faq-question:hover {
        padding-left: 12px;
    }

    .faq-question h3 {
        font-size: 18px;
        font-weight: 700;
        color: #000000;
        margin: 0;
        line-height: 1.4;
        flex: 1;
    }

    .toggle-icon {
        font-size: 24px;
        color: #000000;
        font-weight: 300;
        margin-left: 24px;
        flex: 0 0 auto;
        transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .toggle-icon.active {
        transform: rotate(45deg);
    }

    .faq-answer {
        padding: 0 0 24px 0;
        color: #666666;
        font-size: 15px;
        line-height: 1.8;
    }

    .faq-divider {
        height: 1px;
        background: rgba(0, 0, 0, 0.08);
        margin-bottom: 0;
    }

    .faq-item:last-child .faq-divider {
        display: none;
    }

    /* TRANSITIONS */
    .expand-enter-active, .expand-leave-active {
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .expand-enter, .expand-leave-to {
        opacity: 0;
        max-height: 0;
    }

    /* ============ CONTACT SECTION ============ */
    .contact-section {
        text-align: center;
        padding: 80px 40px;
        background: #f5f5f5;
        border-radius: 24px;
        margin-top: 80px;
    }

    .contact-section h3 {
        font-size: 32px;
        font-weight: 800;
        color: #000000;
        margin-bottom: 12px;
    }

    .contact-section p {
        font-size: 16px;
        color: #666666;
        margin-bottom: 32px;
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
    }

    .btn-contact {
        display: inline-block;
        background: #000000;
        color: white;
        border-radius: 50px;
        padding: 16px 40px;
        font-weight: 600;
        font-size: 16px;
        text-decoration: none;
        transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    }

    .btn-contact:hover {
        transform: translateY(-4px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
        background: #333333;
    }

    /* ============ RESPONSIVE ============ */
    @media (max-width: 960px) {
        .faq-header {
            padding: 60px 0 40px;
        }

        .faq-title {
            font-size: 40px;
        }

        .faq-subtitle {
            font-size: 16px;
        }

        .faq-content {
            padding: 60px 0;
        }

        .contact-section {
            padding: 60px 30px;
            margin-top: 60px;
        }

        .contact-section h3 {
            font-size: 24px;
        }
    }

    @media (max-width: 600px) {
        .faq-header {
            padding: 40px 0 30px;
        }

        .faq-title {
            font-size: 28px;
        }

        .faq-subtitle {
            font-size: 14px;
        }

        .faq-content {
            padding: 40px 0;
        }

        .faq-question {
            padding: 16px 0;
        }

        .faq-question h3 {
            font-size: 15px;
        }

        .toggle-icon {
            font-size: 20px;
            margin-left: 16px;
        }

        .faq-answer {
            font-size: 14px;
            padding: 0 0 16px 0;
        }

        .contact-section {
            padding: 40px 20px;
            margin-top: 40px;
        }

        .contact-section h3 {
            font-size: 20px;
        }

        .contact-section p {
            font-size: 14px;
        }
    }
</style>